export default __webpack_public_path__ + "static/media/incoming-call.c0167e5d.svg";